import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-progress-bar',
    templateUrl: './progress-bar.component.html',
    styleUrls: ['./progress-bar.component.scss'],
    standalone: false
})
export class ProgressBarComponent {
  @Input() value: number = 0; // Accepts a value between 0 and 100
  @Input() loading: boolean = false; // When true, activates loading animation
}
